export var maxLengthProjectName = 55;